import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  isPeppol: boolean;
  loading?: boolean;
  onConfirm: () => void;
};

export const ConfirmDownloadFcInvoiceDialog = ({ isPeppol, loading, onConfirm }: Props) => {
  const { t } = useTranslation(['common', 'invoices']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('invoices:details.confirmDownloadFcInvoiceModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        {isPeppol
          ? `${t('invoices:details.confirmDownloadFcInvoiceModal.peppol')} ${t('invoices:details.confirmDownloadFcInvoiceModal.description')}`
          : t('invoices:details.confirmDownloadFcInvoiceModal.description')}
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" loading={loading} onClick={onConfirm}>
          {t('invoices:details.confirmDownloadFcInvoiceModal.buttonText')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
